var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5332 21.5104C40.9412 11.8368 59.5332 15.2128 59.5332 29.1904C59.5332 38.528 51.5332 47.0539 35.5332 54.768C19.5332 47.056 11.5332 38.5302 11.5332 29.1904C11.5332 15.2128 30.1252 11.8368 35.5332 21.5104Z",
    fill: "#DE5858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.311 14.7776C13.7254 15.8912 9.9334 19.424 9.9334 25.5872C9.9334 33.792 16.8742 41.8208 32.3334 49.4208C47.7926 41.8208 54.7334 33.792 54.7334 25.5872C54.7334 19.4272 50.9414 15.8912 46.3558 14.7776C41.6486 13.632 36.3654 15.1072 33.623 18.8416C33.4744 19.044 33.2802 19.2086 33.0561 19.322C32.8321 19.4354 32.5845 19.4946 32.3334 19.4946C32.0823 19.4946 31.8347 19.4354 31.6107 19.322C31.3866 19.2086 31.1924 19.044 31.0438 18.8416C28.3014 15.1072 23.0182 13.632 18.311 14.7776ZM32.3334 15.4496C28.5254 11.632 22.631 10.432 17.5558 11.664C11.7414 13.0816 6.7334 17.7472 6.7334 25.5872C6.7334 35.9552 15.5846 44.8896 31.639 52.64C31.8556 52.7444 32.093 52.7986 32.3334 52.7986C32.5738 52.7986 32.8112 52.7444 33.0278 52.64C49.0822 44.8896 57.9334 35.9584 57.9334 25.5872C57.9334 17.7472 52.9254 13.0816 47.111 11.6672C42.0358 10.4352 36.1446 11.6384 32.3334 15.4496Z",
    fill: "#DE5858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.9f611b30cbb16e0e7a13f31ba7478271.svg";
export { ForwardRef as ReactComponent };